import apiCall from './call'

const model = 'notifications'

const state = {
  all: [],
  count: 0
}

const getters = {
  total: state => state.count,
  all: state => state.all
}

const actions = {
  getNotifications ({ commit }) {
    return new Promise((resolve, reject) => {
      apiCall({ url: model, qs: { 'view': 'unread' } })
        .then(response => {
          commit('setNotifications', response.data)
          commit('setCount', response.count)
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  dismissNotifications ({ commit }, notification) {
    return new Promise((resolve, reject) => {
      apiCall({ url: model + '/' + notification, method: 'PUT' })
        .then(response => {
          commit('setNotifications', response.data)
          commit('setCount', response.count)
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}

const mutations = {
  setNotifications (state, notifications) {
    state.all = notifications
  },
  setCount (state, unread) {
    state.count = unread
  },
  dismissNotifications (state, notifications) {
    // TODO
  }
}

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/notifications.js